<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <sub-group-create-or-update v-model="subGroup" :editing="editing" :errors="errors"></sub-group-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :buttons="buttons"
                    name="sub-group"
                    :add-callback="createNew"
                    search
                    pagination="server"
                    :fields="fields"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import SubGroupCreateOrUpdate from './components/SubGroupCreateOrUpdate.vue'
import MaintenanaceOperationsApi from '@/api/maintenance-operations'
export default {
    components:{
        BCard,
        SubGroupCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Kod",key:"Code",thClass:"w-20",sortable:true},
                {name:"Ana Grup",key:"MainGroupOfMaintenanceInventoryName",sortKey:'MainGroupOfMaintenanceInventory.Name',thClass:"w-40",sortable:true},
                {name:"Alt Grup",key:"Name",thClass:"w-40",sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            subGroup:{
                Id:null,
                Name:null,
                MainGroupOfMaintenanceInventoryId:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.subGroup.Id = null
            this.subGroup.Name = null
            this.subGroup.MainGroupOfMaintenanceInventoryId = null
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.subGroup.Id = item.Id
            this.subGroup.Name = item.Name
            this.subGroup.MainGroupOfMaintenanceInventoryId = item.MainGroupOfMaintenanceInventoryId
            this.$showModal("create-or-update")
        },
        createNew(){
            this.clearForm()
            this.$showModal("create-or-update")
        },
        provider(data){
            return MaintenanaceOperationsApi.SubGroup.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            MaintenanaceOperationsApi.SubGroup.CreateOrUpdate(this.editing,this.subGroup).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("create-or-update")
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} alt grubunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    MaintenanaceOperationsApi.SubGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>